import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { PI_CART_FAILURE_LOGGER_API } from '~shared/modules/shopping-cart-global/constants';

@Injectable({
  providedIn: 'root',
})
export class CartFailureLoggerService implements OnDestroy {
  private destroySubject$ = new Subject();

  constructor(private httpClient: HttpClient) {}

  logCartFailure(
    idItem: string,
    idOffer: string,
    isGuest: boolean,
    market: string,
    offerPrice: number,
    hasVolumePrice: boolean,
    sellerName: string,
    leafCategoryId: string,
    leafCategoryName: string,
    quantity:number,
    error: any
  ) {
    const url = PI_CART_FAILURE_LOGGER_API();
    const body = { idItem, idOffer, isGuest, market, offerPrice, hasVolumePrice, sellerName, leafCategoryId,
      leafCategoryName, quantity, error };

    return this.httpClient.post<{}>(url, body);
  }

  ngOnDestroy() {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }
}
